import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ApprovedExpert from '../../../widgets/approvedExpert/ApprovedExpert'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import {
  getMultiApproveExpertData,
  getMultiApproveExpertSchema,
  getSchema,
} from '../../../redux/actions/approveExpert'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { startLoading, doneLoading } from '../../../utils/loading'
import scrollToComponent from 'react-scroll-to-component'
import { Message, Panel, Row } from 'rsuite'
import ProjectDataTable from '../../../widgets/dataTable/ProjectDataTable'
import { getPaymentCheck } from '../../../redux/actions/paymentCheck'
import { getGranteeProfileInfoForDirectorSchema } from '../../../redux/actions/granteeProfileInfoForDirector'
import Budget from '../../../widgets/budget/Budget'
import GranteeProfileInfo from '../../../widgets/granteeProfileInfo/GranteeProfileInfo'
import ApproveExpertWidgetMulti from '../../../widgets/approveExpertWidget/ApproveExpertWidgetMulti'

export default function ApproveExpertMulti() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isReLoading, setIsReLoading] = useState(false)
  const [selectedProject, setSelectedProject] = useState()
  const [selectedError, setSelectedError] = useState()
  const [section, setSection] = useState()
  const [dataTableSection, setDataTableSection] = useState()
  const [projectList, setProjectList] = useState()
  const [selectedProjectDetail, setSelectedProjectDetail] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getMultiApproveExpertSchema(projectId)
      setSchema(_schema)
      setProjectList(_schema?.forms?.projectList)
    } catch (e) {}
    doneLoading()
    setIsLoading(false)
  }

  const handleReload = async (pagesize, pagenumber) => {
    setIsReLoading(true)
    startLoading()
    try {
      setSelectedProjectDetail('')
      setSelectedProject('')
      const response = await getMultiApproveExpertData(projectId, pagesize, pagenumber)
      setProjectList(response)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsReLoading(false)
  }

  const onSelected = async (obj) => {
    console.log('obj', obj)
    setSelectedError(false)
    startLoading()
    try {
      setSelectedProjectDetail('')
      setSelectedProject(obj)

      const granteeProfile = await getGranteeProfileInfoForDirectorSchema(obj.id)
      console.log('onSelected granteeProfile = ', granteeProfile)

      const paymentCheck = await getPaymentCheck(obj.id)
      console.log('onSelected paymentCheck = ', paymentCheck)

      const approveReviewer = await getSchema(obj.id)
      console.log('onSelected approveReviewer = ', approveReviewer)

      let _schema = {
        granteeProfile: granteeProfile?.forms?.granteeProfile,
        paymentCheck: paymentCheck?.forms,
        projectInfo: approveReviewer?.model?.forms?.ProjectInfo,
        reviewerApproveList: approveReviewer?.model?.forms?.ReviewerApproveList,
        reviewerSelectList: approveReviewer?.model?.forms?.ReviewerSelectList,
      }

      if (_schema) {
        _schema['header'] = obj.projectName
        setSelectedProjectDetail(_schema)
        scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
      }
    } catch (e) {
      console.log('e', e)
      setSelectedError(true)
    }

    doneLoading()
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isMultiApproveReviewer>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isMultiApproveReviewer>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      {schema?.forms?.reviewerApproveList &&
        schema?.forms?.reviewerApproveList.itemsList?.length > 0 && (
          <div style={{ marginTop: 10 }}>
            <ApprovedExpert schema={schema.forms.reviewerApproveList} />
          </div>
        )}

      {schema?.forms?.reviewerSelectList && (
        <div style={{ marginTop: 10 }}>
          <ApproveExpertWidgetMulti
            schema={schema.forms.reviewerSelectList}
            onUpdateSchema={() => handleGetSchema()}
          />
        </div>
      )}

      {projectList && (
        <div style={{ marginBottom: 10 }}>
          <ProjectDataTable
            schema={projectList}
            single={{
              enable: true,
              buttonText: 'แสดง',
              hideText: false,
              width: 90,
            }}
            onSingleSubmit={onSelected}
            pagination={true}
            onReload={handleReload}
            loading={isReLoading}
          />
        </div>
      )}

      <Row
        ref={(section) => {
          setSection(section)
        }}
      >
        {selectedError && (
          <>
            <Message
              showIcon
              type="error"
              description={`ดึงข้อมูลโครงการ ${selectedProject?.projectName || ''} ไม่สำเร็จ`}
            />
            <br />
          </>
        )}
      </Row>

      {selectedProjectDetail && (
        <Panel
          shaded
          header={`โครงการ ${selectedProjectDetail.header}`}
          bordered
          collapsible
          defaultExpanded
          style={{ marginTop: 10, marginBottom: 20 }}
        >
          {selectedProjectDetail.projectInfo && (
            <div style={{ marginTop: 10 }}>
              <ProjectBasicInfo schema={selectedProjectDetail.projectInfo} />
            </div>
          )}

          {selectedProjectDetail.granteeProfile && (
            <div style={{ marginTop: 10 }}>
              <GranteeProfileInfo schema={selectedProjectDetail.granteeProfile} />
            </div>
          )}

          {selectedProjectDetail.paymentCheck && (
            <div style={{ marginTop: 10 }}>
              <Budget
                schema={selectedProjectDetail.paymentCheck}
                isEditable={false}
                onClick={() => {}}
                isHidePeriodExpenses={true}
                // onClickConfirmBudget={handleConfirmBudget}
              />
            </div>
          )}

          {selectedProjectDetail.reviewerApproveList &&
            selectedProjectDetail.reviewerApproveList.itemsList?.length > 0 && (
              <div style={{ marginTop: 10 }}>
                <ApprovedExpert schema={selectedProjectDetail.reviewerApproveList} />
              </div>
            )}

          {selectedProjectDetail.reviewerSelectList && (
            <div style={{ marginTop: 10 }}>
              <ApprovedExpert schema={selectedProjectDetail.reviewerSelectList} />
            </div>
          )}
        </Panel>
      )}
    </SidebarProposal>
  )
}
